export const STORAGE = {
  ACCESS_TOKEN_ITEM: "currentUser",
  REFRESH_TOKEN: "rfUser",
  USER_STATE: "alice_user_state",
  USER: "user"
}
